import { isString, trimCharsStart } from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import config from 'config'
import { SmartImage } from 'shared/components'

import * as styles from './styles'

const trimSlashes = trimCharsStart('/')

function generateLogoUrl(logo) {
  if (!logo) return null
  return logo.includes('//')
    ? logo
    : `${config.assets.baseUrl}${trimSlashes(logo)}`
}
const InWinImageComponent = ({ source, fallbackSource, ...props }) => {
  let renderImageError

  if (isString(fallbackSource)) {
    renderImageError = (className) => (
      <SmartImage {...props} source={fallbackSource} className={className} />
    )
  }

  return (
    <SmartImage
      {...props}
      source={`${generateLogoUrl(source)}`}
      renderImageError={renderImageError}
      css={styles.fluidImage}
    />
  )
}

InWinImageComponent.propTypes = {
  source: PropTypes.string,
  fallbackSource: PropTypes.string,
}

export default InWinImageComponent
